const canonicalize = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(canonicalize);

  return Object.keys(obj).sort().reduce((acc, key) => {
    acc[key] = canonicalize(obj[key]);
    return acc;
  }, {});
};


export default class Crypto {
  static async generateHash(data) {
    const sortedData = canonicalize(data);
    const jsonString = JSON.stringify(sortedData);
    const msgBuffer = new TextEncoder().encode(jsonString);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    return Array.from(new Uint8Array(hashBuffer))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  }

  static async importSecret(secret) {
    const binaryString = window.atob(secret);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i += 1) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    // eslint-disable-next-line no-return-await
    return await window.crypto.subtle.importKey('raw', bytes, { name: 'AES-GCM' }, false, ['encrypt', 'decrypt']);
  }

  static async encrypt(data, key) {
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const encodedData = new TextEncoder().encode(JSON.stringify(data));
    const ciphertext = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, encodedData);
    return { ciphertext, iv };
  }

  static async decrypt(record, key) {
    try {
      const decrypted = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: record.iv }, key, record.ciphertext);
      return JSON.parse(new TextDecoder().decode(decrypted));
    } catch (e) {
      throw new Error('Decryption failed. Wrong password or corrupted data.');
    }
  }
}
